var map = {
	"./employee-synchronization.md": 590,
	"./employee-synchronization_SK.md": 591,
	"./inventory-management.md": 592,
	"./inventory-management_SK.md": 593,
	"./it-department-website.md": 594,
	"./it-department-website_SK.md": 595,
	"./mxarchive.md": 596,
	"./mxarchive_SK.md": 597,
	"./process-automation.md": 598,
	"./process-automation_SK.md": 599,
	"./task-management.md": 600,
	"./task-management_SK.md": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;